import { registerGroup, registerImage, registerRect, registerText } from '@visactor/vrender-kits';

export function loadEmptyTipComponent() {
  registerGroup();
  // registerRect();
  registerText();
  registerImage();
}
